import { render, staticRenderFns } from "./KPIChart.vue?vue&type=template&id=51a86db8"
import script from "./KPIChart.vue?vue&type=script&lang=js"
export * from "./KPIChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports